import {cn} from '../lib/cn';

export type LoadingBarProps = {
  className?: string;
};

export function LoadingBar({className}: LoadingBarProps) {
  return (
    <div className={cn('w-full p-4', className)}>
      <div className="relative h-1 w-full overflow-hidden rounded-full bg-[var(--chekin-color-white)]">
        <div className="absolute top-0 h-full animate-[chekin-loading-bar_0.8s_linear_infinite] rounded-full bg-[var(--primary)]" />
      </div>
    </div>
  );
}
